import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {getDashboard, getReportDashboard, DashboardProvider, useDashboardDispatch, useDashboardState} from '../../contexts/DashboardContext';
import Dashboard from './Dashboard';
import CircularProgress from '@material-ui/core/CircularProgress';

// eslint-disable-next-line react/no-multi-comp
const Loading = () => (
    <div style={{display: 'flex', width: '100%', justifyContent: 'center', paddingTop: '20px'}}>
        <CircularProgress />
    </div>
);
// eslint-disable-next-line react/no-multi-comp
const Error = () => (<div>Error</div>);

const fetchData = (dispatch, options) => {
    if (options.term.length !== 0) {
        getReportDashboard(dispatch, options);
        return;
    }
    getDashboard(dispatch);
};

const {keys} = Object;
const _isEqual = (a, b) => {
    const keyA = keys(a);

    return keyA.length === keys(b).length && keyA.every(key => hasOwnProperty.call(b, key) && b[key] === a[key]);
};

// eslint-disable-next-line react/no-multi-comp
const Container = ({term, options}) => {
    const state = useDashboardState();
    const dispatch = useDashboardDispatch();
    const {data: dashboardData = {data: {}}, loading, error} = state.dashboard;

    const [dashboardOptions, setDashboardOptions] = useState({});

    useEffect(() => {
        const config = {...options, term};

        if (!_isEqual(dashboardOptions, config)) {
            setDashboardOptions(config);
            fetchData(dispatch, {...options, term});
        }

        return () => {
        };
    }, [dispatch, term, options, dashboardOptions]);

    if (loading || !dashboardData) return <Loading />;
    if (error) return <Error />;

    return (
        <Dashboard {...dashboardData.data} />
    );
};

Container.propTypes = {
    term: PropTypes.string,
    options: PropTypes.object,
};

// eslint-disable-next-line react/no-multi-comp
const DashboardContainer = ({term = '', options = {}}) => {
    return (
        <DashboardProvider>
            <Container
                term={term}
                options={options}
            />
        </DashboardProvider>
    );
};

DashboardContainer.propTypes = {
    term: PropTypes.string,
    options: PropTypes.object,
};

export default DashboardContainer;
